<template>
  <ion-page>
    <ion-header>
      <ion-toolbar class="topbar">
        <ion-buttons slot="start">
          <ion-icon
            :icon="chevronBackOutline"
            fill="clear"
            color="Medium"
            @click="onClose"
          ></ion-icon>
        </ion-buttons>
        <ion-title>图片</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div
        style="
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img :src="imageUrl" />
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonIcon,
} from "@ionic/vue";

import { chevronBackOutline } from "ionicons/icons";

export default {
  name: "UserInfo",
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonIcon,
  },
  props: ["imageUrl"],

  setup() {
    return {
      chevronBackOutline,
    };
  },

  mounted() {
    this.userinfo = this.store.getUser();
  },
};
</script>
